import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3589c08a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = { style: {"position":"fixed","right":"3%","top":"47%","font-size":"30px","color":"#0088f6","cursor":"pointer","z-index":"100"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"width":"100% !important","white-space":"nowrap"} }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 1,
  style: {"float":"left","width":"15px","text-align":"left"},
  title: "已加入拼单预览"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"width":"100% !important","white-space":"nowrap"} }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = {
  key: 0,
  style: {"width":"99% !important","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 5 }
const _hoisted_19 = {
  key: 0,
  style: {"width":"99% !important","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = {
  key: 0,
  style: {"width":"99% !important","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 7 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { class: "overSP" }
const _hoisted_31 = ["onMouseenter"]
const _hoisted_32 = {
  key: 1,
  class: "overSP"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 拼单预览 ", -1))
const _hoisted_34 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["title"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["title"]
const _hoisted_44 = ["title"]
const _hoisted_45 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_48 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = ["onClick", "title"]
const _hoisted_53 = ["title"]
const _hoisted_54 = ["title"]
const _hoisted_55 = ["onClick", "title"]
const _hoisted_56 = ["title"]
const _hoisted_57 = ["title"]
const _hoisted_58 = ["title"]
const _hoisted_59 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }
const _hoisted_62 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_63 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = ["title"]
const _hoisted_71 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_72 = ["title"]
const _hoisted_73 = ["title"]
const _hoisted_74 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_75 = ["title"]
const _hoisted_76 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_77 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = ["onClick", "title"]
const _hoisted_82 = ["title"]
const _hoisted_83 = ["title"]
const _hoisted_84 = ["onClick", "title"]
const _hoisted_85 = ["title"]
const _hoisted_86 = ["title"]
const _hoisted_87 = ["title"]
const _hoisted_88 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"}
}
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 添加方案 ", -1))
const _hoisted_92 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_93 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShoppingCart = _resolveComponent("ShoppingCart")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_Flag = _resolveComponent("Flag")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_dynamic_search = _resolveComponent("miezz-dynamic-search")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_wharf_plan = _resolveComponent("miezz-wharf-plan")!
  const _component_miezz_wharf_in_stock = _resolveComponent("miezz-wharf-in-stock")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.cartNumber > 0)
        ? (_openBlock(), _createBlock(_component_el_badge, {
            key: 0,
            value: _ctx.cartNumber,
            class: "item",
            onClick: _ctx.onCart
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { title: "拼单预览" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ShoppingCart)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "onClick"]))
        : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            title: "拼单预览",
            onClick: _ctx.onCart
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ShoppingCart)
            ]),
            _: 1
          }, 8, ["onClick"])),
      (_ctx.programmeCount > 0)
        ? (_openBlock(), _createBlock(_component_el_badge, {
            key: 2,
            value: _ctx.programmeCount,
            class: "item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onProgramme(undefined)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, {
                style: {"margin-left":"20px"},
                title: "方案"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Flag)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
        : (_openBlock(), _createBlock(_component_el_icon, {
            key: 3,
            style: {"margin-left":"20px"},
            title: "方案",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onProgramme(undefined)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Flag)
            ]),
            _: 1
          }))
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_miezz_page_list, {
      ref: "ref-miezz-page-list",
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleGet(undefined))),
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleRadioSearch: _ctx.handleRadioSearch
    }, {
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_BookingNo')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.bookingNos,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : (model.Where.Prop == 'DynamicSearch_Code')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 1,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.codes,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : (model.Where.Prop == 'DynamicSearch_ClientUserId')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 2,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.clientUsers,
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_LoadingPortId')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 3,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.loadingPorts,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : (model.Where.Prop == 'DynamicSearch_DeliveryPortId')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 4,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.deliveryPorts,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : (model.Where.Prop == 'DynamicSearch_DeliveryPlaceLabel')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 5,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.deliveryPlaces,
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              : (model.Where.Prop == 'DynamicSearch_DeparturePortDrawback')
                ? (_openBlock(), _createBlock(_component_miezz_select, {
                    key: 6,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                    options: _ctx.drawbacks,
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                : (model.Where.Prop == 'DynamicSearch_ServiceRemark')
                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                      key: 7,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      options: _ctx.serviceRemarks,
                      clearable: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                  : (model.Where.Prop == 'DynamicSearch_Status')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 8,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.EnumOrderStowageStackStatusOption,
                        number: true,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_ProgrammeId')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 9,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.programmes,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : _createCommentVNode("", true)
      ]),
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'ServiceRemark')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  style: _normalizeStyle(`float: left; width: ${
                row.TabCount > 0 &&
                row.OrderPrePackedBoxId != null &&
                row.OrderPrePackedBoxId != undefined &&
                row.OrderPrePackedBoxId != ''
                  ? 'calc(100% + 20px)'
                  : row.TabCount > 0 ||
                    (row.OrderPrePackedBoxId != null &&
                      row.OrderPrePackedBoxId != undefined &&
                      row.OrderPrePackedBoxId != '')
                  ? 'calc(100% + 10px)'
                  : '100%'
              }
; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `)
                }, [
                  (row.TabCount > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle([{"float":"left","width":"15px","text-align":"left"}, row.TabCount > 1 ? 'color:red;' : '']),
                        title: row.TabName
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Flag)
                          ]),
                          _: 1
                        }),
                        _createTextVNode("  ")
                      ], 12, _hoisted_5))
                    : _createCommentVNode("", true),
                  (
                  row.OrderPrePackedBoxId != null &&
                  row.OrderPrePackedBoxId != undefined &&
                  row.OrderPrePackedBoxId != ''
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ShoppingCart)
                          ]),
                          _: 1
                        }),
                        _createTextVNode("  ")
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_miezz_text_ellipsis, {
                    title: row.ServiceRemark,
                    text: row.ServiceRemark ?? '暂无数据'
                  }, null, 8, ["title", "text"])
                ], 4)
              ])
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'BookingNo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  (
                  row.BookingNo != null &&
                  row.BookingNo != undefined &&
                  row.BookingNo != ''
                )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `#/order/pool/summary/${row.Id}`,
                        target: "_blank"
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          title: row.BookingNo,
                          text: row.BookingNo ?? '暂无数据'
                        }, null, 8, ["title", "text"])
                      ], 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "暂无数据"))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'OrderCode' && row.OrderCode)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: `#/order/summary/${row.OrderId}`,
              target: "_blank"
            }, [
              _createVNode(_component_miezz_text_ellipsis, {
                text: row.OrderCode ?? '暂无数据'
              }, null, 8, ["text"])
            ], 8, _hoisted_11))
          : (model.Prop == 'OrderCode')
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "暂无数据"))
            : _createCommentVNode("", true),
        (model.Prop == 'PlanCargoQuantities')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (
              row.PlanCargoQuantities != null &&
              row.PlanCargoQuantities != undefined &&
              row.PlanCargoQuantities != ''
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_ctx.OrderManagement_Pool_Summary_DeparturePortWarehouse == true)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          style: {"cursor":"pointer","color":"#fe995b"},
                          onClick: ($event: any) => (_ctx.onWharf(row.Id))
                        }, _toDisplayString(row.PlanCargoQuantities), 9, _hoisted_15))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.PlanCargoQuantities), 1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'WarehousingCargoQuantities')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (
              row.WarehousingCargoQuantities != null &&
              row.WarehousingCargoQuantities != undefined &&
              row.WarehousingCargoQuantities != ''
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.OrderManagement_Pool_Summary_DeparturePortWarehouse == true)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          style: {"cursor":"pointer","color":"#fe995b"},
                          onClick: ($event: any) => (_ctx.onWharf(row.Id))
                        }, _toDisplayString(row.WarehousingCargoQuantities), 9, _hoisted_20))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(row.WarehousingCargoQuantities), 1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'ExWarehouseCargoQuantities')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (
              row.ExWarehouseCargoQuantities != null &&
              row.ExWarehouseCargoQuantities != undefined &&
              row.ExWarehouseCargoQuantities != ''
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_ctx.OrderManagement_Pool_Summary_DeparturePortWarehouse == true)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          style: {"cursor":"pointer","color":"#fe995b"},
                          onClick: ($event: any) => (_ctx.onWharf(row.Id))
                        }, _toDisplayString(row.ExWarehouseCargoQuantities), 9, _hoisted_25))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.ExWarehouseCargoQuantities), 1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_27, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'WarehousingAddress')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (row.WarehousingAddress)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    placement: "top",
                    disabled: row.tooltipFlag,
                    "show-after": 500,
                    ref: 'tooltip' + row.Id
                  }, {
                    content: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.WarehousingAddressList, (p, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(p), 1),
                            _hoisted_29
                          ])
                        ]))
                      }), 128))
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_30, [
                        _createElementVNode("span", {
                          onMouseenter: ($event: any) => (_ctx.visibilityChange($event, row))
                        }, _toDisplayString(row.WarehousingAddress), 41, _hoisted_31)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["disabled"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, "暂无数据"))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick", "onHandleRadioSearch"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAllocate,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalAllocate) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.listAllocate.Dto)
          ? (_openBlock(), _createBlock(_component_miezz_dynamic_search, {
              key: 0,
              ref: "miezz-dynamic-search",
              modelValue: _ctx.listAllocate.Dto.DynamicSearchId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listAllocate.Dto.DynamicSearchId) = $event)),
              items: _ctx.listAllocate.DynamicSearchItems,
              disabledHistories: true,
              fixProp: true,
              code: _ctx.listAllocate.PowerCode,
              simple: _ctx.listAllocate.SimpleDynamicSearch,
              ignoreResetProps: _ctx.listAllocate.DynamicSearchIgnoreResetProps,
              onHandleSearch: _ctx.handleAllocateDynamicSearch
            }, {
              "dynamic-search-customize": _withCtx(({ model }) => [
                (model.Where.Prop == 'DynamicSearch_LoadingPortId')
                  ? (_openBlock(), _createBlock(_component_miezz_text_ellipsis, {
                      key: 0,
                      text: model.Where.Label
                    }, null, 8, ["text"]))
                  : (model.Where.Prop == 'DynamicSearch_DeliveryPortId')
                    ? (_openBlock(), _createBlock(_component_miezz_text_ellipsis, {
                        key: 1,
                        text: model.Where.Label
                      }, null, 8, ["text"]))
                    : (model.Where.Prop == 'DynamicSearch_Code')
                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                          key: 2,
                          modelValue: model.Where.Value,
                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                          options: _ctx.filterAllocateCodes,
                          filterMethod: _ctx.getAllocateCodes,
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "filterMethod"]))
                      : (model.Where.Prop == 'DynamicSearch_MasterBillNo')
                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                            key: 3,
                            modelValue: model.Where.Value,
                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                            options: _ctx.allocateMasterBillNos,
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : (model.Where.Prop == 'DynamicSearch_DeliveryPlaceLabel')
                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                              key: 4,
                              modelValue: model.Where.Value,
                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                              options: _ctx.allocateDeliveryPlaces,
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                          : (model.Where.Prop == 'DynamicSearch_CustomerServiceId')
                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 5,
                                modelValue: model.Where.Value,
                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                options: _ctx.allocateCustomerServices,
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                            : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "items", "code", "simple", "ignoreResetProps", "onHandleSearch"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_miezz_page_list, {
          modelValue: _ctx.listAllocate,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listAllocate) = $event)),
          onHandleGet: _ctx.handleGetAllocate
        }, null, 8, ["modelValue", "onHandleGet"]), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCreate,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalCreate) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-create",
          model: _ctx.modalCreateData,
          rules: _ctx.modalCreateRules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "订单编号",
              prop: "Code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.modalCreateData.Code,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalCreateData.Code) = $event)),
                  pattern: "[0-9a-zA-Z]",
                  upperCase: true,
                  trimAll: true,
                  placeholder: "选填，未填写时系统会自动生成订单编号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "CustomerServiceId",
              label: "客服"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.modalCreateData.CustomerServiceId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalCreateData.CustomerServiceId) = $event)),
                  label: _ctx.modalCreateData.CustomerServiceLabel,
                  "onUpdate:label": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalCreateData.CustomerServiceLabel) = $event)),
                  options: _ctx.customerServices,
                  clearable: false
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.prePackedBox.Visible,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.prePackedBox.Visible) = $event)),
      "show-close": false,
      style: {"width":"100%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "$prePackedBox",
          modelValue: _ctx.prePackedBox,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.prePackedBox) = $event)),
          fix: true,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "装货港",
                      "label-width": "120px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.prePackedBox.LoadingPortLabel), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "目的港",
                      "label-width": "120px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.prePackedBox.DeliveryPortLabel), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.prePackedBox.IsNewCharge == true)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 12,
                      style: {"display":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "计费类型",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_miezz_select, {
                              modelValue: _ctx.prePackedBox.Type,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.prePackedBox.Type) = $event)),
                              onChange: _ctx.onChangeType,
                              options: _ctx.types,
                              clearable: false
                            }, null, 8, ["modelValue", "onChange", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.prePackedBox.IsNewCharge == true)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 12,
                      style: {"display":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "规则",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.prePackedBox.Type == 10)
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 0,
                                  modelValue: _ctx.prePackedBox.CompanyChargeId,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.prePackedBox.CompanyChargeId) = $event)),
                                  clearable: false,
                                  options: _ctx.prePackedBox.Weights,
                                  onChange: _ctx.onChangeWeight,
                                  onClear: _ctx.onChangeWeight
                                }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
                              : _createCommentVNode("", true),
                            (_ctx.prePackedBox.Type == 20)
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 1,
                                  modelValue: _ctx.prePackedBox.CompanyChargeId,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.prePackedBox.CompanyChargeId) = $event)),
                                  clearable: false,
                                  options: _ctx.prePackedBox.Volumes,
                                  onChange: _ctx.onChangeVolume,
                                  onClear: _ctx.onChangeVolume
                                }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.prePackedBox.IsNewCharge == false)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 2,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "材积比",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.prePackedBox.VolumeRatioWeight,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.prePackedBox.VolumeRatioWeight) = $event)),
                              placeholder: "请填写",
                              style: {"width":"100% !important"},
                              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onChangeVolumeRatioWeight()))
                            }, {
                              prepend: _withCtx(() => [
                                _createTextVNode(" 1m³ / ")
                              ]),
                              append: _withCtx(() => [
                                (_ctx.prePackedBox.Type == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "KGS"))
                                  : _createCommentVNode("", true),
                                (_ctx.prePackedBox.Type == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, "CBM"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.prePackedBox.IsNewCharge == false)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 3,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "单件最低计费重",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.prePackedBox.MinimumChargeableWeight,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.prePackedBox.MinimumChargeableWeight) = $event)),
                              placeholder: "请填写",
                              style: {"width":"100% !important"},
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onChangeMinimumChargeableWeight()))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.prePackedBox.Type == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "KGS"))
                                  : _createCommentVNode("", true),
                                (_ctx.prePackedBox.Type == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, "CBM"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.prePackedBox.IsNewCharge == false)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 4,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "单票最低计费重",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.prePackedBox.OneMinimumChargeableWeight,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.prePackedBox.OneMinimumChargeableWeight) = $event)),
                              placeholder: "请填写",
                              style: {"width":"100% !important"},
                              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onChangeOneMinimumChargeableWeight()))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.prePackedBox.Type == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, "KGS"))
                                  : _createCommentVNode("", true),
                                (_ctx.prePackedBox.Type == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, "CBM"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_table, {
          ref: "prePackedBoxTable",
          data: _ctx.prePackedBox.Pools,
          border: "",
          script: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "ServiceRemark",
              width: "90",
              label: "服务内容"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.ServiceRemark
                    }, _toDisplayString(_ctx.isString(scope.row.ServiceRemark)), 9, _hoisted_41))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, "—"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "BookingNo",
              width: "120",
              label: "BookingNo"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                  title: scope.row.BookingNo
                }, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 9, _hoisted_43)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Client",
              label: "委托人"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.Client
                    }, _toDisplayString(_ctx.isString(scope.row.Client)), 9, _hoisted_44))
                  : (_openBlock(), _createElementBlock("div", _hoisted_45, " — "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Address",
              width: "100",
              label: "最终目的地"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.Address
                    }, _toDisplayString(_ctx.isString(scope.row.Address)), 9, _hoisted_46))
                  : (_openBlock(), _createElementBlock("div", _hoisted_47, " — "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "IsTax",
              width: "85",
              label: "是否退税"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (scope.row.IsTax == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "是"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_50, "否"))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_51, "—"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "PlanCargoQuantities",
              width: "300",
              label: "计划货量"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onPlan(scope.row)),
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","color":"#fe995b","cursor":"pointer","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.PlanCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.PlanCargoQuantities)), 9, _hoisted_52))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                      title: scope.row.PlanCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.PlanCargoQuantities)), 9, _hoisted_53))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "PlanCargoQuantitiesWeight",
              width: "160",
              label: "计划计费标准"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                  title: scope.row.PlanCargoQuantitiesWeightString
                }, _toDisplayString(scope.row.PlanCargoQuantitiesWeightString), 9, _hoisted_54)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "WarehousingCargoQuantities",
              width: "300",
              label: "入库货量"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onInStock(scope.row)),
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","color":"#fe995b","cursor":"pointer","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.WarehousingCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.WarehousingCargoQuantities)), 9, _hoisted_55))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.WarehousingCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.WarehousingCargoQuantities)), 9, _hoisted_56))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "WarehousingCargoQuantitiesWeightString",
              width: "160",
              label: "入库计费标准"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                  title: scope.row.WarehousingCargoQuantitiesWeightString
                }, _toDisplayString(scope.row.WarehousingCargoQuantitiesWeightString), 9, _hoisted_57)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "WarehousingAddress ",
              label: "入库地点"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.WarehousingAddress
                    }, _toDisplayString(_ctx.isString(scope.row.WarehousingAddress)), 9, _hoisted_58))
                  : (_openBlock(), _createElementBlock("div", _hoisted_59, " — "))
              ]),
              _: 1
            }),
            (_ctx.isDetail != true)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "操作",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    (scope.$index < _ctx.prePackedBox.Pools.length - 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.onDelete(scope.$index)),
                          title: "删除"
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_60))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.prePackedBoxBottomButtons,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.prePackedBoxBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickPrePackedBox
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_wharf_plan, {
      ref: "WharfPlan",
      isDetail: true
    }, null, 512),
    _createVNode(_component_miezz_wharf_in_stock, {
      ref: "WharfInStock",
      orderPoolId: _ctx.poolId,
      isDetail: true
    }, null, 8, ["orderPoolId"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.programmeFromVisible,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.programmeFromVisible) = $event)),
      "show-close": false,
      style: {"width":"100%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.programmeFrom.ActiveName,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.programmeFrom.ActiveName) = $event)),
            type: "card",
            class: "demo-tabs",
            onTabClick: _ctx.handleClickTabs
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programmeFrom.Tabs, (p, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: p.Name,
                  name: p.Id,
                  key: index
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "$programmeFrom",
          modelValue: _ctx.programmeFrom,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.programmeFrom) = $event)),
          fix: true,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "装货港",
                      "label-width": "120px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.programmeFrom.LoadingPortLabel), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "目的港",
                      "label-width": "120px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.programmeFrom.DeliveryPortLabel), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.programmeFrom.IsNewCharge == true)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 12,
                      style: {"display":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "计费类型",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_miezz_select, {
                              modelValue: _ctx.programmeFrom.Type,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.programmeFrom.Type) = $event)),
                              onChange: _ctx.onChangeTypeProgramme,
                              options: _ctx.types,
                              disabled: true,
                              clearable: false
                            }, null, 8, ["modelValue", "onChange", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.programmeFrom.IsNewCharge == true)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 12,
                      style: {"display":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "规则",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.programmeFrom.Type == 10)
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 0,
                                  modelValue: _ctx.programmeFrom.CompanyChargeId,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.programmeFrom.CompanyChargeId) = $event)),
                                  clearable: false,
                                  disabled: true,
                                  options: _ctx.programmeFrom.Weights,
                                  onChange: _ctx.onChangeWeightProgramme,
                                  onClear: _ctx.onChangeWeightProgramme
                                }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
                              : _createCommentVNode("", true),
                            (_ctx.programmeFrom.Type == 20)
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 1,
                                  modelValue: _ctx.programmeFrom.CompanyChargeId,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.programmeFrom.CompanyChargeId) = $event)),
                                  clearable: false,
                                  disabled: true,
                                  options: _ctx.programmeFrom.Volumes,
                                  onChange: _ctx.onChangeVolumeProgramme,
                                  onClear: _ctx.onChangeVolumeProgramme
                                }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.programmeFrom.IsNewCharge == false)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 2,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "材积比",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.programmeFrom.VolumeRatioWeight,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.programmeFrom.VolumeRatioWeight) = $event)),
                              placeholder: "请填写",
                              style: {"width":"100% !important"},
                              onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onChangeVolumeRatioWeightProgramme()))
                            }, {
                              prepend: _withCtx(() => [
                                _createTextVNode(" 1m³ / ")
                              ]),
                              append: _withCtx(() => [
                                (_ctx.programmeFrom.Type == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, "KGS"))
                                  : _createCommentVNode("", true),
                                (_ctx.programmeFrom.Type == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "CBM"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.programmeFrom.IsNewCharge == false)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 3,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "单件最低计费重",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.programmeFrom.MinimumChargeableWeight,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.programmeFrom.MinimumChargeableWeight) = $event)),
                              placeholder: "请填写",
                              style: {"width":"100% !important"},
                              onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onChangeMinimumChargeableWeight()))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.programmeFrom.Type == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "KGS"))
                                  : _createCommentVNode("", true),
                                (_ctx.programmeFrom.Type == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_67, "CBM"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.programmeFrom.IsNewCharge == false)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 4,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "单票最低计费重",
                          "label-width": "120px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.programmeFrom.OneMinimumChargeableWeight,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.programmeFrom.OneMinimumChargeableWeight) = $event)),
                              placeholder: "请填写",
                              style: {"width":"100% !important"},
                              onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onChangeOneMinimumChargeableWeight()))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.programmeFrom.Type == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, "KGS"))
                                  : _createCommentVNode("", true),
                                (_ctx.programmeFrom.Type == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, "CBM"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_table, {
          ref: "programmeFromTable",
          data: _ctx.programmeFrom.Pools,
          border: "",
          script: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "ServiceRemark",
              width: "85",
              label: "服务内容"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.ServiceRemark
                    }, _toDisplayString(_ctx.isString(scope.row.ServiceRemark)), 9, _hoisted_70))
                  : (_openBlock(), _createElementBlock("div", _hoisted_71, " — "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "BookingNo",
              width: "120",
              label: "BookingNo"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                  title: scope.row.BookingNo
                }, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 9, _hoisted_72)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Client",
              label: "委托人"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.Client
                    }, _toDisplayString(_ctx.isString(scope.row.Client)), 9, _hoisted_73))
                  : (_openBlock(), _createElementBlock("div", _hoisted_74, " — "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Address",
              width: "100",
              label: "最终目的地"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.Address
                    }, _toDisplayString(_ctx.isString(scope.row.Address)), 9, _hoisted_75))
                  : (_openBlock(), _createElementBlock("div", _hoisted_76, " — "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "IsTax",
              width: "85",
              label: "是否退税"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      (scope.row.IsTax == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_78, "是"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_79, "否"))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_80, "—"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "PlanCargoQuantities",
              width: "300",
              label: "计划货量"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onPlan(scope.row)),
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","color":"#fe995b","cursor":"pointer","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.PlanCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.PlanCargoQuantities)), 9, _hoisted_81))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                      title: scope.row.PlanCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.PlanCargoQuantities)), 9, _hoisted_82))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "PlanCargoQuantitiesWeight",
              width: "160",
              label: "计划计费标准"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                  title: scope.row.PlanCargoQuantitiesWeightString
                }, _toDisplayString(scope.row.PlanCargoQuantitiesWeightString), 9, _hoisted_83)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "WarehousingCargoQuantities",
              width: "300",
              label: "入库货量"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onInStock(scope.row)),
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","color":"#fe995b","cursor":"pointer","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.WarehousingCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.WarehousingCargoQuantities)), 9, _hoisted_84))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.WarehousingCargoQuantities
                    }, _toDisplayString(_ctx.isString(scope.row.WarehousingCargoQuantities)), 9, _hoisted_85))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "WarehousingCargoQuantitiesWeightString",
              width: "160",
              label: "入库计费标准"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                  title: scope.row.WarehousingCargoQuantitiesWeightString
                }, _toDisplayString(scope.row.WarehousingCargoQuantitiesWeightString), 9, _hoisted_86)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "WarehousingAddress ",
              label: "入库地点"
            }, {
              default: _withCtx((scope) => [
                (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px","text-overflow":"ellipsis","white-space":"nowrap"},
                      title: scope.row.WarehousingAddress
                    }, _toDisplayString(_ctx.isString(scope.row.WarehousingAddress)), 9, _hoisted_87))
                  : (_openBlock(), _createElementBlock("div", _hoisted_88, " — "))
              ]),
              _: 1
            }),
            (_ctx.isDetail != true)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "操作",
                  width: "60"
                }, {
                  default: _withCtx((scope) => [
                    (scope.$index < _ctx.programmeFrom.Pools.length - 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.onDeleteProgramme(scope.$index)),
                          title: "删除"
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_89))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_90, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.programmeBottomButtons,
            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.programmeBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickProgramme
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.programmeNameForm.Visiable,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.programmeNameForm.Visiable) = $event)),
      "show-close": false,
      style: {"width":"30%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_91,
        _createElementVNode("div", _hoisted_92, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "$programmeNameForm",
          model: _ctx.programmeNameForm,
          fix: true,
          rules: _ctx.programmeNameRules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "名称",
                      "label-width": "80px",
                      prop: "Name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.programmeNameForm.Name,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.programmeNameForm.Name) = $event)),
                          placeholder: "请填写",
                          style: {"width":"100% !important"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_93, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.programmeNameBottomButtons,
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.programmeNameBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickProgrammeName
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}